import React, { useContext } from 'react';
import { Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import CommonInputText from '../components/CommonInputText';
import { Trouble } from '../models/dashboard-models';
import { AddProps } from '../models/table-models';
import { useAddTrouble } from '../utils/dashboard-hooks';
import {BranchesContext} from "../context/BranchesContext";
import {toast} from "react-toastify";
import {CustomToastContent} from "../components/CustomToastContent";
import {toastOptionsTopRight} from "../utils/Enums/ToastOptions";

export const AddTrouble = ({ setShowModal, itemRelatedId, refetchEntitiesHook  }: AddProps) => {
    const { t } = useTranslation('translation', { keyPrefix: 'common' });
    const { taskManagerBranches } = useContext(BranchesContext);
    const { register, handleSubmit, formState} = useForm<Trouble>({
        mode: 'all',
    });

    const useSubmitHandlerAdd = async (formValue: Trouble) => {
        if(itemRelatedId) formValue.branchId = itemRelatedId;
        await useAddTrouble(formValue);
        refetchEntitiesHook();
        setShowModal(false);
        toast.success(<CustomToastContent content={[t('troubleSuccess')]} />, toastOptionsTopRight);
    };

    return (
        <Form
            id='form'
            className='d-flex flex-column align-items-center p-4  w-100'
            noValidate
            onSubmit={handleSubmit(useSubmitHandlerAdd)}
        >
            <Form.Group className=' d-flex flex-column mb-2 align-items-start w-100 ' controlId='title'>
                <label className='mb-1'>{t('branch')}</label>
                <Form.Select {...register("branchId")}
                             disabled={!!itemRelatedId}
                             defaultValue={itemRelatedId ? itemRelatedId : ''}>
                    {taskManagerBranches.map((branch, index) => (
                        <option key={index} value={branch.id}
                        >
                            {branch.name}
                        </option>
                    ))}
                </Form.Select>
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-2 align-items-start w-100 ' controlId='title'>
                <CommonInputText
                    id='title'
                    label={t('title')}
                    labelTextColor='text-black'
                    type='text'
                    fieldError={formState.errors.title}
                    hookRegister={register('title', {
                        required: {
                            value: true,
                            message: t('title'),
                        },
                    })}
                />
            </Form.Group>
            <Form.Group className=' d-flex flex-column mb-2 align-items-start w-100 ' controlId='description'>
                <CommonInputText
                    id='description'
                    label={t('description')}
                    labelTextColor='text-black'
                    type='text'
                    fieldError={formState.errors.description}
                    hookRegister={register('description', {
                        required: {
                            value: true,
                            message: t('description'),
                        },
                    })}
                />
            </Form.Group>
        </Form>
    );
};
